"use client";

import Link from "next/link";
import { getFooterInfo } from "@/app/_lib/api";
import { useEffect, useState } from "react";

export default function Footer({ baseUrl }: { baseUrl: string }) {
  const [info, setInfo] = useState({
	org: "",
    phone: "",
    email: "",
    address: "",
    code: "",
    reference: "",
  });

  useEffect(() => {
    const getInfo = async () => {
      const res = await fetch(`${baseUrl}/api/footer`);
      setInfo(JSON.parse((await res.json())?.data?.content));
    };

    getInfo();
  }, []);

  return (
    <footer className="h-[122px] py-[22px] line-height-[26px] text-white text-sm text-center  bg-[#002455]">
      <div className="w-[1200px] mx-auto">
        <div className="h-[26px]">
          <span className="pr-[8px]">{info.org}</span>
          {/* {pathname == href ? (
            <span className="cursor-pointer">网站地图</span>
          ) : (
            <Link href={href}>网站地图</Link>
          )} */}
        </div>
        <div className="h-[26px]">
          <span className="pr-[8px]">{info.phone}</span>
          <span className="pr-[8px]">{info.email}</span>
          <span className="pr-[8px]">{info.address}</span>
          <span>{info.code}</span>
        </div>
        <div className="h-[26px]">
          {/* <div
            onClick={() =>
              window.open(
                "https://beian.miit.gov.cn/#/Integrated/index",
                "_blank"
              )
            }
            // href="https://beian.miit.gov.cn/#/Integrated/index"
            // target="_blank"
          >
            鄂ICP备16013996号
          </div> */}
          <Link
            href="https://beian.miit.gov.cn/#/Integrated/index"
            passHref
            legacyBehavior
          >
            <a target="_blank">{info.reference}</a>
          </Link>
          {/* <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
          >
            鄂ICP备16013996号
          </a> */}
        </div>
      </div>
    </footer>
  );
}
